// This file contains a 1:1 mapping between route names and paths to avoid importing the entire
// route definitions (and imports) everytime this map is needed, which can cause masse drops in
// performance for the production builds.

import { generatePath } from 'react-router-dom';

const routeNames = {
  welcome: '/welcome',
  token: '/token',
  login: '/login',
  home: '/home',
  tour: '/tour',
  termsAndCondition: '/terms',
  privacyPolicy: '/privacy-policy',

  bids: '/bids',
  pendingBids: '/bids/pending',
  pastBids: '/bids/past-bids',
  bidDetails: '/bids/details/:id',

  shifts: '/shifts',
  shiftDetails: '/shifts/:type/details/:id',
  openShifts: '/shifts/open',
  myShifts: '/shifts/my-shifts',
  myShiftsCalendar: '/shifts/my-shifts/calendar',
  pastShifts: '/shifts/past-shifts',
  reviewBids: '/shifts/review-bids',
  bidsPlaced: '/shifts/bids-placed',
  hospitalProfile: '/shifts/location/hospital/:code',

  docs: '/docs',
  profile: '/profile',
  profileEdit: '/profile/edit',
  licenses: '/profile/licenses',
  addLicense: '/profile/license/add',
  editLicense: '/profile/license/:number',
  registrations: '/profile/registrations',
  addRegistration: '/profile/registration/add',
  editRegistration: '/profile/registration/:number',
  insurances: '/profile/insurances',
  addInsurance: '/profile/insurance/add',
  editInsurance: '/profile/insurance/:policyNumber',

  help: '/help',
  faq: '/help/faq/:section?',
  contact: '/help/contact/:subjectId?',

  onboarding: '/onboarding',
  recovery: '/onboarding/recovery',
  yourInfo: '/onboarding/your-info',
  qualifications: '/onboarding/qualifications',
  onboardingSuccess: '/onboarding/success',
  recover: '/onboarding/recover',
  careers: '/onboarding/careers',

  discount: '/discount',
} satisfies { [key: string]: `/${string}` };

export const publicPaths = [
  '/welcome',
  '/token',
  '/discount',
  '/terms',
  '/privacy-policy',
  '/onboarding',
  '/onboarding/recovery',
  '/onboarding/your-info',
  '/onboarding/qualifications',
  '/onboarding/success',
  '/onboarding/recover',
  '/onboarding/careers',
];

export const paths = (
  routeName: keyof typeof routeNames,
  params?: object,
): string => {
  const path = routeNames[routeName];
  if (!routeNames[routeName]) {
    console.warn(`Route for ${routeName} is not defined`);
  }

  return params ? generatePath(path, params) : path;
};
